import script from "./OnlineChatHtmlContentDisplay.vue?vue&type=script&lang=ts&setup=true"
export * from "./OnlineChatHtmlContentDisplay.vue?vue&type=script&lang=ts&setup=true"

import "./OnlineChatHtmlContentDisplay.vue?vue&type=style&index=0&id=27a552f6&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27a552f6"]])

export default __exports__